import React, { useEffect, useState, useRef } from "react";
import { Box, Button, Flex, Icon } from "@nubeteck/components";
import { FlexStyled } from "../../../components/registration/register-confirmation/confirmation.styled";
import {
  ButtonAlternativeStyled,
  ButtonPrimaryStyled,
  ButtonsContainer,
} from "../../../components/custom/buttons/buttons.styled";
import {
  SectionHeaderStyled,
  SmallHeadingStyled,
} from "../../../components/custom/texts/texts.styled";
import { Bill, CardsGroup, ResumeList, ScrollView } from "../../../components";
import toast from "react-hot-toast";
import { BillBoxStyled, BillFlexStyled } from "../../../components/billing/bill/bill.styled";
import { NoResultsSVG } from "src/assets";
import { Image, MenuProps, Modal, Skeleton, Form, Input, Select, Segmented } from "antd";
import {
  DropdownSubIcon,
  ResumeCardStyled,
  ResumeFlexStyled,
} from "../../../components/billing/resume-card/resumeCard.styled";
import {
  toastErrorStyle,
  toastWarningStyle,
  useSuccessOperationCompletedToast,
  useErrorGenericToast,
  useSuccessPaymentCompletedToast,
} from "src/constants";
import { ICartItem } from "src/Interfaces/cart";
import {
  CartHeadingStyled,
  CartResumeContainerStyled,
  FeesContainerStyled,
  ImageButtonContainerStyled,
} from "src/pages/student-pages/cart/cart.styled";
import {
  CardText,
  CardTitle,
  CardUserInvoiceName,
} from "src/components/reports/cards/report-cards.styled";
import { ArrayUtils, FormatterUtils } from "@nubeteck/utils";
import { PaymentSVG } from "src/assets";
import { useMediaQuery } from "src/hooks";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useNavigate, useParams } from "react-router-dom";
import { useGetStudentsMutation } from "src/services";
import {
  useDeleteCartItemAdminMutation,
  useGetCartAdminMutation,
  useGetDatafonesQuery,
  useSaveBillAdminMutation,
  useSaveInvoicePersonDataAdminMutation,
} from "src/services/chargesSettingsServices";
import { useGetIsThereAPaymentInProcessMutation } from "src/services/cartServices";
import CartMoneyInfo from "src/components/billing/cart-money-info/cart-money-info";
import ThirdPersonForm from "src/pages/student-pages/cart/third-person-form";
import { getBoxPage, getUserEnrollementPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { StrapiError } from "../../StrapiError";
import { formatDate } from "src/utils/date-util";
declare global {
  interface Window {
    AlignetVPOS2?: { openModal: (host: string, designID: number) => void };
  }
}

interface IRegisterStepProps {
  id: number;
  title: string;
  component: JSX.Element;
}
interface IFees {
  id: number;
  descripcion: string;
  saldo: number;
  moneda: number;
  fechaVencimiento: string;
}

export const ChargesSettings = () => {
  const [modal, contextHolder] = Modal.useModal();
  const { locale } = useLocale();
  const [boxPage, setBoxPage] = useState<any>(null);
  const [userEnrollementPage, setUserEnrollementPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [totalPendiente, setTotalPendiente] = useState({ colones: 0, dolares: 0 });
  const [totalCuotas, setTotalCuotas] = useState(0);
  const [currentStep, setCurrentStep] = React.useState<number>(0);
  const [totalAmountCol, setTotalAmountCol] = useState(0);
  const [totalAmountDol, setTotalAmountDol] = useState(0);
  const [cargosMonedas, setCargosMonedas] = useState({ colones: true, dolares: false });
  const [cuotasPasadas, setCuotasPasadas] = useState<IFees[]>([]);
  const [modalInvoiceData, setModalInvoiceData] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState({ id: 0, name: "" });
  const [paymentType, setPaymentType] = useState(0);
  const [noReferencia, setNoReferencia] = useState<string>();
  const [hasError, setHasError] = useState<boolean>(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  
  const showSuccessOperationCompletedToast = useSuccessOperationCompletedToast();
  const showErrorGenericToast = useErrorGenericToast();
  const showSuccessPaymentCompletedToast = useSuccessPaymentCompletedToast();

  const [getCart, { data: cartInfo, isLoading, errorGettingCart }] = useGetCartAdminMutation();
  const [getPaymentInProcess, { isLoading: isLoadingGettingPaymentInProcess }] =
    useGetIsThereAPaymentInProcessMutation();
  const [saveCart, { isLoading: isLoadingPayment, error: errorPayment }] =
    useSaveBillAdminMutation();
  const [
    deleteItem,
    { isLoading: isLoadingDeleting, isSuccess: isSuccessDeleting, isError: isErrorDeleting },
  ] = useDeleteCartItemAdminMutation();
  const [
    savePerson,
    { isLoading: isLoadingSavingPerson, isSuccess: isSuccesSavingPerson, error: errorSavingPerson },
  ] = useSaveInvoicePersonDataAdminMutation();

  const { isLoading: isLoadingPaymentTypes, data: paymentTypes } = useGetDatafonesQuery("");

  const [materiasCuotas, setMateriasCuotas] = useState<Array<{ id: number; costo: number }>>([]);
  const [form, setForm] = useState<any>({
    saldoAFavorAUsarColones: 0,
    saldoAFavorAUsarDolar: 0,
    cantidadCuotas: 0,
    montoTransferencia: 0,
    monedaTransferencia: 0,
  });

  const [getStudents, { data: students, isLoading: isLoadingStudents }] = useGetStudentsMutation();

  const { previous } = useParams();
  const navigate = useNavigate();

  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setBoxPage(null);
        setUserEnrollementPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    
    const loadContent = async () => {
      try {
        const [boxRes, userEnrollementRes] = await Promise.all([
          getBoxPage(locale),
          getUserEnrollementPage(locale)
        ]);
        
        if (!cancel) {
          clearTimeout(timeoutId);
          setBoxPage(boxRes?.data?.attributes || boxRes?.data || boxRes);
          setUserEnrollementPage(userEnrollementRes?.data?.attributes || userEnrollementRes?.data || userEnrollementRes);
          setIsLoadingContent(false);
        }
      } catch (error) {
        if (!cancel) {
          clearTimeout(timeoutId);
          setBoxPage(null);
          setUserEnrollementPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      }
    };
    
    loadContent();
    
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  useEffect(() => {
    const tempMatCuotas = cartInfo?.data?.matriculasCuotas?.map((mat: any) => ({
      id: mat.matriculaId,
      costo: mat.costo,
    }));
    if (
      selectedStudent.id !== 0 &&
      JSON.stringify(tempMatCuotas ?? []) !== JSON.stringify(materiasCuotas ?? [])
    )
      getCart({ id: selectedStudent.id, materiasCuotas: materiasCuotas?.map((mat) => mat.id) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materiasCuotas]);

  useEffect(() => {
    if (selectedStudent.id !== 0)
      getCart({ id: selectedStudent.id, materiasCuotas: materiasCuotas?.map((mat) => mat.id) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessDeleting, selectedStudent]);

  useEffect(() => {
    getStudents({
      rowsCount: 50,
      page: 1,
      estudianteNombre: "",
    });
  }, [getStudents]);

  useEffect(() => {
    setTotalCuotas(materiasCuotas?.map((mat) => mat.costo).reduce((prev, next) => prev + next, 0));
  }, [materiasCuotas]);

  useEffect(() => {
    if (cartInfo?.data?.matriculasCuotas)
      setMateriasCuotas(
        cartInfo?.data?.matriculasCuotas?.map((mat: any) => ({
          id: mat.matriculaId,
          costo: mat.costo,
        })),
      );
    setCuotasPasadas(cartInfo?.data?.saldosNoVencidos);
    if (
      cartInfo?.data?.asignaturas?.length === 0 &&
      cartInfo?.data?.servicios?.length === 0 &&
      (cartInfo?.data?.colones?.deuda?.saldoNoVencido > 0 ||
        cartInfo?.data?.colones?.deuda?.saldoVencido > 0 ||
        cartInfo?.data?.dolares?.deuda?.saldoNoVencido > 0 ||
        cartInfo?.data?.dolares?.deuda?.saldoVencido > 0)
    ) {
      setCurrentStep(1);
    }
    const infoColones = cartInfo?.data?.colones;
    const infoDolares = cartInfo?.data?.dolares;

    setTotalPendiente({
      colones:
        infoColones?.deuda?.costoTotal -
        infoColones?.descuento?.totalDescuentoBeca -
        infoColones?.descuento?.totalDescuentoPatrocinio,
      dolares:
        infoDolares?.deuda?.costoTotal -
        infoDolares?.descuento?.totalDescuentoBeca -
        infoDolares?.descuento?.totalDescuentoPatrocinio,
    });
    setCargosMonedas({
      colones:
        infoColones?.deuda?.saldoNoVencido > 0 ||
        infoColones?.deuda?.saldoVencido > 0 ||
        cartInfo?.data?.asignaturas.find((as: ICartItem) => as.monedaId === 2) !== undefined ||
        cartInfo?.data?.servicios.find((ser: ICartItem) => ser.monedaId === 2) !== undefined,
      dolares:
        infoDolares?.deuda?.saldoNoVencido > 0 ||
        infoDolares?.deuda?.saldoVencido > 0 ||
        cartInfo?.data?.asignaturas.find((as: ICartItem) => as.monedaId === 1) !== undefined ||
        cartInfo?.data?.servicios.find((ser: ICartItem) => ser.monedaId === 1) !== undefined,
    });
    // const hasColones =
    //   infoColones?.deuda?.saldoNoVencido > 0 ||
    //   infoColones?.deuda?.saldoVencido > 0 ||
    //   cartInfo?.data?.asignaturas.some((as: ICartItem) => as.monedaId === 2) ||
    //   cartInfo?.data?.servicios.some((ser: ICartItem) => ser.monedaId === 2);

    // const hasDolares =
    //   infoDolares?.deuda?.saldoNoVencido > 0 ||
    //   infoDolares?.deuda?.saldoVencido > 0 ||
    //   cartInfo?.data?.asignaturas.some((as: ICartItem) => as.monedaId === 1) ||
    //   cartInfo?.data?.servicios.some((ser: ICartItem) => ser.monedaId === 1);

    // setCargosMonedas({
    //   colones: hasColones || (!hasColones && !hasDolares),
    //   dolares: hasDolares && !(hasColones || (!hasColones && !hasDolares)),
    // });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartInfo]);

  useEffect(() => {
    if (errorPayment) {
      toast.error(errorPayment?.data?.message, toastErrorStyle);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorPayment]);
  useEffect(() => {
    if (errorGettingCart) {
      toast.error(errorGettingCart?.data?.message, toastErrorStyle);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorGettingCart]);

  useEffect(() => {
    if (errorSavingPerson) {
      toast.error(errorSavingPerson?.data?.message, toastErrorStyle);
    }
    if (isSuccesSavingPerson) {
      showSuccessOperationCompletedToast();
      getCart({ id: selectedStudent.id, materiasCuotas });
      setModalInvoiceData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorSavingPerson, isSuccesSavingPerson, showSuccessOperationCompletedToast]);

  useEffect(() => {
    if (isErrorDeleting) {
      showErrorGenericToast();
    }
    if (isSuccessDeleting) {
      showSuccessOperationCompletedToast();
    }
  }, [isSuccessDeleting, isErrorDeleting, showErrorGenericToast, showSuccessOperationCompletedToast]);

  const studentsOptions = ArrayUtils.selectLabelValue(
    students?.data?.result ?? [],
    "estudianteNombre",
    "estudianteId",
  );
  const paymentOptions = ArrayUtils.selectLabelValue(
    paymentTypes?.data ?? [],
    "verifoneName",
    "verifoneId",
  );

  const itemsSubjects: (data: any) => MenuProps["items"] = (data) => [
    {
      key: "1",
      label: boxPage?.delete_option_label || "Eliminar",
      icon: <DropdownSubIcon name="" color="#c4c1c1" />,
      onClick: () => {
        confirmDelete(
          { itemId: data.seccionId, esAsignatura: true },
          data.nombre,
          data.matriculaId,
        );
      },
    },
  ];

  const itemsServices: (data: any) => MenuProps["items"] = (data) =>
    !data.esObligatorio
      ? [
          {
            key: "2",
            label: boxPage?.delete_option_label || "Eliminar",
            icon: <DropdownSubIcon name="" color="#c4c1c1" />,
            onClick: () => {
              confirmDelete({ itemId: data.solicitudId, esAsignatura: false }, data.nombre);
            },
          },
        ]
      : undefined;

  const confirmDelete = (data: any, name: string, matriculaId?: number) => {
    modal.confirm({
      title: `${boxPage?.remove_item_title_prefix || "Remover"} ${data.esAsignatura ? "asignatura" : "servicio"}`,
      icon: <Icon name="" color="#FFC53D" />,
      content: `${boxPage?.remove_item_content_prefix || "¿Es seguro que desea remover de la factura"} ${
        data.esAsignatura ? "la asignatura" : "el servicio"
      } ${name}?`,
      okText: boxPage?.ok_button || "Aceptar",
      onOk: () => {
        deleteItem({ ...data, peopleId: selectedStudent.id });
        setMateriasCuotas(materiasCuotas?.filter((mat) => mat.id !== matriculaId));
      },
      cancelText: boxPage?.cancel_button || "Cancelar",
      style: { top: 200 },
    });
  };

  const displayWarning = () => {
    toast(
      <div>
        <h3 style={toastWarningStyle.style}>
          {boxPage?.browser_warning_title ||
            "NO CIERRE EL NAVEGADOR HASTA QUE SE TRAMITE SU TRANSACCIÓN."}
        </h3>
        <p>
          {boxPage?.browser_warning_content ||
            "Una vez procesado el pago recibirá un correo con los detalles del recibo. El estudiante recibirá una copia por correo."}
        </p>
      </div>,
      {
        duration: 5000,
        style: {
          padding: "30px",
          fontSize: 17,
          height: "100%",
          fontWeight: 700,
          boxShadow: "0 0 0 50vmax rgba(0,0,0,.5)",
        },
      },
    );
  };

  const getIsPaymentFieldsVisible = () => {
    if (totalAmountCol > 0.1 || totalAmountDol > 0.1) return true;
  };

  const obtenerValidaciones = async (currency: number) => {
    const validacionPagoEnProceso = await getPaymentInProcess(selectedStudent.id).then(
      (res: any) => {
        if (res?.data?.data === false) {
          return true;
        } else {
          return false;
        }
      },
    );

    const saldoAFavorAUsar =
      currency === 188 ? form.saldoAFavorAUsarColones : form.saldoAFavorAUsarDolar;
    const total = currency === 188 ? totalAmountCol : totalAmountDol;
    const pendiente = currency === 188 ? totalPendiente.colones : totalPendiente.dolares;

    let error = null;
    if (total > 0.1) {
      if (paymentType == 0)
        error =
          boxPage?.datafono_required_message ||
          "Debe seleccionar un tipo de datáfono para poder efectuar el pago.";
      if (!noReferencia)
        error = boxPage?.reference_required_message || "El número de referencia del pago es requerido.";
    }

    if (error === null) {
      if (!validacionPagoEnProceso) {
        modal.confirm({
          title: `${boxPage?.duplicate_payment_title || "Este estudiante tiene un pago que aún está siendo procesado."}`,
          icon: <Icon name="" color="#FFC53D" />,
          content: `${boxPage?.duplicate_payment_content || "¿Está seguro(a) de que desea continuar y realizar un nuevo pago?"}`,
          okText: boxPage?.continue_button || "Continuar",
          onOk: () => {
            realizarPago(total, pendiente, saldoAFavorAUsar, currency);
          },
          cancelText: boxPage?.cancel_button || "Cancelar",
          style: { top: 200 },
        });
      } else {
        realizarPago(total, pendiente, saldoAFavorAUsar, currency);
      }
    } else {
      toast(error, toastErrorStyle);
    }
  };

  const realizarPago = (
    total: number,
    pendiente: number,
    saldoAFavorAUsar: number,
    monedaId: number,
  ) => {
    displayWarning();
    saveCart({
      peopleId: selectedStudent.id,
      data: {
        verifoneId: paymentType,
        saldoAFavorAUsar: saldoAFavorAUsar,
        cantidadCuotas:
          cartInfo?.data?.numeroCuotas >= 1 && materiasCuotas.length > 0
            ? cartInfo?.data?.numeroCuotas
            : 0,
        saldoNoVencidoAPagar: total - pendiente > 0 ? total - pendiente : 0,
        totalPago: total.toFixed(2),
        totalPagoTransferencia: form.montoTransferencia,
        monedaId,
        monedaTransferencia: form.monedaTransferencia,
        matriculasEnCuotasInt: materiasCuotas.map((mat) => mat.id),
        referencia: noReferencia,
      },
    }).then((res: any) => {
      if (res?.data?.responseStatus == "Success") {
        showSuccessPaymentCompletedToast();
        navigate(`/last-receipt/${cartInfo?.data?.pagoIdActual}/${selectedStudent.id}`);
      }
    });
  };

  const marcarParaCuotas = (matriculaId: number, costo: number) => {
    if (materiasCuotas?.find((mat) => mat.id === matriculaId)) {
      setMateriasCuotas(materiasCuotas?.filter((mat) => mat.id !== matriculaId));
    } else {
      setMateriasCuotas(materiasCuotas?.concat([{ id: matriculaId, costo }]));
    }
  };

  const changePastFeesGettingPaid = (monto: number, moneda: number) => {
    if (cuotasPasadas?.length > 0) {
      let resto = monto;
      const cuotasTemp: IFees[] = [];

      cartInfo?.data?.saldosNoVencidos?.forEach((fee: IFees) => {
        let saldo = fee.saldo;
        if (resto > 0 && fee.moneda === moneda) {
          saldo = saldo - resto;
          if (saldo < 0) {
            resto = saldo * -1;
            saldo = 0;
          } else {
            resto = 0;
          }
        }
        cuotasTemp.push({ ...fee, saldo });
      });

      setCuotasPasadas(cuotasTemp);
    }
  };

  if (hasError && locale === 'en') {

    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setBoxPage(null);
      }}
    />;
  }

  const invoiceHeader = (
    <>
      <CardsGroup
        userInfoCustom={{ fullName: selectedStudent?.name, id: cartInfo?.data?.matriculaId }}
        extraContent={
          <>
            <CardUserInvoiceName direction="vertical">
              <CardTitle style={{ fontSize: "18px" }}>{isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (boxPage?.bill || "Factura a nombre de")}</CardTitle>
              <Flex>
                <CardText>
                  {isLoading ? "..." : cartInfo?.data?.estudianteTercero?.terceroNombre}
                </CardText>{" "}
                <Button
                  disabled={isLoading}
                  size="small"
                  type="link"
                  onClick={() => {
                    setModalInvoiceData(true);
                  }}
                >
                  {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 80 }} /> : (boxPage?.change_button || "Cambiar")}
                </Button>
              </Flex>
            </CardUserInvoiceName>
            <CartMoneyInfo
              cargosMonedas={cargosMonedas}
              totalCuotas={totalCuotas}
              totalPendiente={totalPendiente}
              reglaEstimacion={cartInfo?.data?.regla?.reglaEstimada}
            />

            <ThirdPersonForm
              initialValues={cartInfo?.data?.estudianteTercero}
              open={modalInvoiceData}
              savePerson={(values: any) => savePerson({ ...values, peopleId: selectedStudent.id })}
              isLoading={isLoadingSavingPerson}
              onCancel={() => {
                setModalInvoiceData(false);
              }}
            />
          </>
        }
      />
    </>
  );

  const steps: IRegisterStepProps[] = [
    {
      id: 0,
      title: isLoadingContent ? "..." : `${boxPage?.subtitle || "Carrito del estudiante"} ${selectedStudent?.name?.split("-")[0]}`,
      component: (
        <>
          {invoiceHeader}

          <FlexStyled>
            <CartResumeContainerStyled>
              {isLoading || isLoadingPayment || isLoadingDeleting ? (
                <>
                  <ResumeCardStyled>
                    <ResumeFlexStyled>
                      <Skeleton.Image active />
                      <Skeleton loading={true} active round title={false} />
                    </ResumeFlexStyled>
                  </ResumeCardStyled>
                  <br />
                  <ResumeCardStyled>
                    <ResumeFlexStyled>
                      <Skeleton.Image active />
                      <Skeleton loading={true} active round title={false} />
                    </ResumeFlexStyled>
                  </ResumeCardStyled>
                </>
              ) : (!cartInfo?.data?.asignaturas && !cartInfo?.data?.servicios) ||
                (cartInfo?.data?.asignaturas?.length == 0 &&
                  cartInfo?.data?.servicios?.length == 0) ? (
                <>
                  {/* <SpinnerContainerStyled>
                    <LargeHeadingStyled>Sin cargos o servicios por pagar</LargeHeadingStyled>
                  </SpinnerContainerStyled> */}
                  <BillBoxStyled>
                    <Segmented
                      options={[
                        { label: isLoadingContent ? "..." : (boxPage?.money_O || "Colones"), value: 1 },
                        { label: isLoadingContent ? "..." : (boxPage?.money_T || "Dolares"), value: 2 },
                      ]}
                      size="large"
                      style={{ marginBottom: "10px" }}
                      defaultValue={1}
                      onChange={(e) => {
                        e == 1
                          ? setCargosMonedas({ colones: true, dolares: false })
                          : setCargosMonedas({ colones: false, dolares: true });
                      }}
                    />
                    <Bill
                      esPagoAFavor={true}
                      hayMateriasOServicios={
                        cartInfo?.data?.asignaturas?.length > 0 ||
                        cartInfo?.data?.servicios?.length > 0
                      }
                      isOnAdmin={true}
                      conversion={cartInfo?.data?.conversion}
                      limiteCuotas={cartInfo?.data?.numeroCuotas}
                      actualizarPagosCuotas={changePastFeesGettingPaid}
                      hayCargosEnColones={cargosMonedas.colones}
                      hayCargosEnDolares={cargosMonedas.dolares}
                      dataTransferencia={
                        cartInfo?.data?.colones?.descuento?.transferencia ??
                        cartInfo?.data?.dolares?.descuento?.transferencia
                      }
                      setTotalAmountColones={(num: number) => {
                        setTotalAmountCol(num);
                      }}
                      setTotalAmountDolares={(num: number) => {
                        setTotalAmountDol(num);
                      }}
                      totalPendienteColones={totalPendiente.colones}
                      totalPendienteDolares={totalPendiente.dolares}
                      setTotalPendienteColones={(num: number) =>
                        setTotalPendiente({ ...totalPendiente, colones: num })
                      }
                      setTotalPendienteDolares={(num: number) =>
                        setTotalPendiente({ ...totalPendiente, dolares: num })
                      }
                      totalCuotas={totalCuotas}
                      pagoCuotas={materiasCuotas?.length > 0}
                      setValue={(obj) => setForm({ ...form, ...obj })}
                      billColones={{
                        ...cartInfo?.data?.colones.deuda,
                        ...cartInfo?.data?.colones.descuento,
                        ...cartInfo?.data?.colones.pago,
                      }}
                      billDolares={{
                        ...cartInfo?.data?.dolares.deuda,
                        ...cartInfo?.data?.dolares.descuento,
                        ...cartInfo?.data?.dolares.pago,
                      }}
                    />
                    <br />

                    <form ref={formRef} method="POST" className="alignet-form-vpos2">
                      {getIsPaymentFieldsVisible() ? (
                        <>
                          <Form.Item label={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 150 }} /> : (boxPage?.dashboardO || "No. de referencia")}>
                            <Input
                              placeholder={isLoadingContent ? "" : (boxPage?.dashboardO || "No. de referencia")}
                              onChange={(e) => {
                                setNoReferencia(e.target.value);
                              }}
                            />
                          </Form.Item>
                          <Form.Item label={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (boxPage?.dashboardT || "Seleccione el método de pago")}>
                            <Select
                              style={{ minWidth: "240px" }}
                              options={paymentOptions}
                              placeholder={isLoadingContent ? "" : (boxPage?.dashboardTR || "Datáfono")}
                              allowClear
                              loading={isLoadingPaymentTypes}
                              onChange={(e) => {
                                setPaymentType(e);
                              }}
                            />
                          </Form.Item>
                        </>
                      ) : null}
                      <ButtonsContainer>
                        <ButtonAlternativeStyled
                          onClick={() => setCurrentStep(currentStep - 1)}
                          type="default"
                          size="large"
                        >
                          {" "}
                          {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 80 }} /> : (userEnrollementPage?.back_button || "Atrás")}
                        </ButtonAlternativeStyled>
                        {cargosMonedas.colones && (
                          <>
                            {totalAmountCol < 0.1 &&
                            (cartInfo?.data?.asignaturas?.length > 0 ||
                              cartInfo?.data?.servicios?.length > 0 ||
                              (cartInfo?.data?.colones?.deuda?.saldoNoVencido > 0 &&
                                (form.saldoAFavorAUsarColones ?? 0) > 0) ||
                              (cartInfo?.data?.colones?.deuda?.saldoVencido > 0 &&
                                (form.saldoAFavorAUsarColones ?? 0) > 0)) ? (
                              <ButtonPrimaryStyled
                                type="primary"
                                disabled={isLoading}
                                size="large"
                                onClick={() => obtenerValidaciones(188)}
                                loading={isLoadingPayment || isLoadingGettingPaymentInProcess}
                              >
                                {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 120 }} /> : (boxPage?.money_O || "Terminar ₡")}
                              </ButtonPrimaryStyled>
                            ) : totalAmountCol > 0.1 ? (
                              <ButtonPrimaryStyled
                                type="primary"
                                disabled={isLoading}
                                size="large"
                                onClick={() => obtenerValidaciones(188)}
                                loading={isLoadingPayment || isLoadingGettingPaymentInProcess}
                              >
                                {cartInfo?.data?.hayCargosEnDolares
                                  ? boxPage?.pay_colones_button || "Pagar cargos en colones"
                                  : boxPage?.pay_card_button || "Pago con tarjeta de débito/crédito"}
                              </ButtonPrimaryStyled>
                            ) : null}
                          </>
                        )}

                        {cargosMonedas.dolares && (
                          <>
                            {totalAmountDol < 0.1 &&
                            (cartInfo?.data?.asignaturas?.length > 0 ||
                              cartInfo?.data?.servicios?.length > 0 ||
                              (cartInfo?.data?.dolares?.deuda?.saldoNoVencido > 0 &&
                                (form.saldoAFavorAUsarDolar ?? 0) > 0) ||
                              (cartInfo?.data?.dolares?.deuda?.saldoVencido > 0 &&
                                (form.saldoAFavorAUsarDolar ?? 0) > 0)) ? (
                              <ButtonPrimaryStyled
                                type="primary"
                                size="large"
                                loading={isLoadingPayment || isLoadingGettingPaymentInProcess}
                                onClick={() => obtenerValidaciones(840)}
                              >
                                {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 120 }} /> : (boxPage?.money_T || "Terminar $")}
                              </ButtonPrimaryStyled>
                            ) : totalAmountDol > 0.1 ? (
                              <ButtonPrimaryStyled
                                type="primary"
                                size="large"
                                loading={isLoadingPayment || isLoadingGettingPaymentInProcess}
                                onClick={() => obtenerValidaciones(840)}
                              >
                                {cargosMonedas.colones
                                  ? boxPage?.pay_dollars_button || "Pagar cargos en dólares"
                                  : boxPage?.pay_card_button || "Pago con tarjeta de débito/crédito"}
                              </ButtonPrimaryStyled>
                            ) : null}
                          </>
                        )}
                      </ButtonsContainer>
                    </form>
                  </BillBoxStyled>
                </>
              ) : null}
              {cartInfo?.data?.asignaturas?.length > 0 && (
                <ResumeList
                  programas={cartInfo?.data?.carreras}
                  isLoading={isLoading}
                  marcarParaCuotas={marcarParaCuotas}
                  viewHeight="40vh"
                  title={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 250 }} /> : (boxPage?.total_subjects || "Materia(s) seleccionada(s):")}
                  listType="subject"
                  listItems={
                    cartInfo?.data?.asignaturas.map((a: ICartItem & { carreraId: number }) => ({
                      ...a,
                      reglaTipoId: cartInfo?.data?.regla?.reglaTipoId,
                      programaId: a.carreraId,
                      pagaCuotas:
                        materiasCuotas.find((mat) => mat.id == a.matriculaId) !== undefined,
                    })) as ICartItem[]
                  }
                  items={itemsSubjects}
                />
              )}
              <br />
              {cartInfo?.data?.servicios?.length > 0 && (
                <ResumeList
                  isLoading={isLoading}
                  viewHeight="30vh"
                  title={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (boxPage?.other_charges || "Servicios:")}
                  listType="service"
                  listItems={cartInfo?.data?.servicios as ICartItem[]}
                  items={itemsServices}
                />
              )}
              <br />
            </CartResumeContainerStyled>
            <ImageButtonContainerStyled>
              <Image src={PaymentSVG} width={300} preview={false} style={{ margin: "50px 0px" }} />
              <br />
              <br />
              <ButtonsContainer>
                {previous !== "general" && (
                  <ButtonAlternativeStyled
                    onClick={() =>
                      navigate(
                        previous === "selection"
                          ? `/subjects-registration/${
                              cartInfo?.data?.carreras?.length == 1
                                ? cartInfo?.data?.carreras[0].carreraId
                                : "initial"
                            }`
                          : "/requests",
                      )
                    }
                    type="default"
                    size="large"
                  >
                    {" "}
                    {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 80 }} /> : (userEnrollementPage?.back_button || "Atrás")}
                  </ButtonAlternativeStyled>
                )}
                {(cartInfo?.data?.asignaturas?.length !== 0 ||
                  cartInfo?.data?.servicios?.length !== 0 ||
                  cartInfo?.data?.colones?.deuda?.saldoNoVencido > 0 ||
                  cartInfo?.data?.colones?.deuda?.saldoVencido > 0 ||
                  cartInfo?.data?.dolares?.deuda?.saldoNoVencido > 0 ||
                  cartInfo?.data?.dolares?.deuda?.saldoVencido > 0) && (
                  <ButtonPrimaryStyled
                    type="primary"
                    disabled={isLoading}
                    size="large"
                    onClick={() => setCurrentStep(currentStep + 1)}
                  >
                    {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (boxPage?.dashboardO || "Siguiente")}
                  </ButtonPrimaryStyled>
                )}
              </ButtonsContainer>
            </ImageButtonContainerStyled>
          </FlexStyled>
        </>
      ),
    },
    {
      id: 1,
      title: isLoadingContent ? "..." : `${boxPage?.subtitle || "Caja del estudiante"} ${selectedStudent.name}`,
      component: (
        <>
          {invoiceHeader}
          <FlexStyled>
            <div>
              <Image src={PaymentSVG} width={400} preview={false} style={{ margin: "100px 0px" }} />
            </div>
            <FlexStyled style={{ gap: "20px" }}>
              {cuotasPasadas?.length > 0 && (
                <ScrollView
                  height={"710px"}
                  style={{ width: "100%", minWidth: "120px", textAlign: "center" }}
                >
                  <>
                    <SmallHeadingStyled style={{ textAlign: "center" }}>
                      {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 150 }} /> : (boxPage?.pending_balance || "Cuotas pendientes")}
                    </SmallHeadingStyled>
                    {cuotasPasadas.map((fee) => (
                      <FeesContainerStyled key={fee.id}>
                        <h5>{fee.descripcion}</h5>
                        <span>
                          {fee.moneda === 2 ? "₡" : "$"}
                          {FormatterUtils.number(fee.saldo.toFixed(2))}
                        </span>
                        <br />
                        <br />
                        <span style={{ color: "#00479B", fontSize: "12px" }}>
                          {boxPage?.due_date_label || "Vence: "}
                          {formatDate(fee.fechaVencimiento)}
                        </span>
                      </FeesContainerStyled>
                    ))}
                  </>
                </ScrollView>
              )}
              <BillBoxStyled>
                <Bill
                  esPagoAFavor={false}
                  hayMateriasOServicios={
                    cartInfo?.data?.asignaturas?.length > 0 || cartInfo?.data?.servicios?.length > 0
                  }
                  isOnAdmin={true}
                  conversion={cartInfo?.data?.conversion}
                  limiteCuotas={cartInfo?.data?.numeroCuotas}
                  actualizarPagosCuotas={changePastFeesGettingPaid}
                  hayCargosEnColones={cargosMonedas.colones}
                  hayCargosEnDolares={cargosMonedas.dolares}
                  dataTransferencia={
                    cartInfo?.data?.colones?.descuento?.transferencia ??
                    cartInfo?.data?.dolares?.descuento?.transferencia
                  }
                  setTotalAmountColones={(num: number) => {
                    setTotalAmountCol(num);
                  }}
                  setTotalAmountDolares={(num: number) => {
                    setTotalAmountDol(num);
                  }}
                  totalPendienteColones={totalPendiente.colones}
                  totalPendienteDolares={totalPendiente.dolares}
                  setTotalPendienteColones={(num: number) =>
                    setTotalPendiente({ ...totalPendiente, colones: num })
                  }
                  setTotalPendienteDolares={(num: number) =>
                    setTotalPendiente({ ...totalPendiente, dolares: num })
                  }
                  totalCuotas={totalCuotas}
                  pagoCuotas={materiasCuotas?.length > 0}
                  setValue={(obj) => setForm({ ...form, ...obj })}
                  billColones={{
                    ...cartInfo?.data?.colones.deuda,
                    ...cartInfo?.data?.colones.descuento,
                    ...cartInfo?.data?.colones.pago,
                  }}
                  billDolares={{
                    ...cartInfo?.data?.dolares.deuda,
                    ...cartInfo?.data?.dolares.descuento,
                    ...cartInfo?.data?.dolares.pago,
                  }}
                />
                <br />

                <form ref={formRef} method="POST" className="alignet-form-vpos2">
                  {getIsPaymentFieldsVisible() ? (
                    <>
                      <Form.Item label={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (boxPage?.dashboardO || "No. de referencia")}>
                        <Input
                          placeholder={isLoadingContent ? "" : (boxPage?.dashboardO || "No. de referencia")}
                          onChange={(e) => {
                            setNoReferencia(e.target.value);
                          }}
                        />
                      </Form.Item>
                      <Form.Item label={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 200 }} /> : (userEnrollementPage?.box_selection.select_input || "Seleccione el método de pago")}>
                        <Select
                          style={{ minWidth: "240px" }}
                          options={paymentOptions}
                          placeholder={boxPage?.datafono_placeholder || "Datáfono"}
                          allowClear
                          loading={isLoadingPaymentTypes}
                          onChange={(e) => {
                            setPaymentType(e);
                          }}
                        />
                      </Form.Item>
                    </>
                  ) : null}
                  <ButtonsContainer>
                    <ButtonAlternativeStyled
                      onClick={() => setCurrentStep(currentStep - 1)}
                      type="default"
                      size="large"
                    >
                      {" "}
                      {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 80 }} /> : (userEnrollementPage?.back_button  || "Atrás")}
                    </ButtonAlternativeStyled>
                    {cargosMonedas.colones && (
                      <>
                        {totalAmountCol < 0.1 &&
                        (cartInfo?.data?.asignaturas?.length > 0 ||
                          cartInfo?.data?.servicios?.length > 0 ||
                          (cartInfo?.data?.colones?.deuda?.saldoNoVencido > 0 &&
                            (form.saldoAFavorAUsarColones ?? 0) > 0) ||
                          (cartInfo?.data?.colones?.deuda?.saldoVencido > 0 &&
                            (form.saldoAFavorAUsarColones ?? 0) > 0)) ? (
                          <ButtonPrimaryStyled
                            type="primary"
                            disabled={isLoading}
                            size="large"
                            onClick={() => obtenerValidaciones(188)}
                            loading={isLoadingPayment || isLoadingGettingPaymentInProcess}
                          >
                            {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 120 }} /> : (boxPage?.money_O || "Terminar ₡")}
                          </ButtonPrimaryStyled>
                        ) : totalAmountCol > 0.1 ? (
                          <ButtonPrimaryStyled
                            type="primary"
                            disabled={isLoading}
                            size="large"
                            onClick={() => obtenerValidaciones(188)}
                            loading={isLoadingPayment || isLoadingGettingPaymentInProcess}
                          >
                            {cartInfo?.data?.hayCargosEnDolares
                              ? boxPage?.pay_colones_button || "Pagar cargos en colones"
                              : boxPage?.pay_card_button || "Pago con tarjeta de débito/crédito"}
                          </ButtonPrimaryStyled>
                        ) : null}
                      </>
                    )}

                    {cargosMonedas.dolares && (
                      <>
                        {totalAmountDol < 0.1 &&
                        (cartInfo?.data?.asignaturas?.length > 0 ||
                          cartInfo?.data?.servicios?.length > 0 ||
                          (cartInfo?.data?.dolares?.deuda?.saldoNoVencido > 0 &&
                            (form.saldoAFavorAUsarDolar ?? 0) > 0) ||
                          (cartInfo?.data?.dolares?.deuda?.saldoVencido > 0 &&
                            (form.saldoAFavorAUsarDolar ?? 0) > 0)) ? (
                          <ButtonPrimaryStyled
                            type="primary"
                            size="large"
                            loading={isLoadingPayment || isLoadingGettingPaymentInProcess}
                            onClick={() => obtenerValidaciones(840)}
                          >
                            {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 120 }} /> : (boxPage?.money_T || "Terminar $")}
                          </ButtonPrimaryStyled>
                        ) : totalAmountDol > 0.1 ? (
                          <ButtonPrimaryStyled
                            type="primary"
                            size="large"
                            loading={isLoadingPayment || isLoadingGettingPaymentInProcess}
                            onClick={() => obtenerValidaciones(840)}
                          >
                            {cargosMonedas.colones
                              ? boxPage?.pay_dollars_button || "Pagar cargos en dólares"
                              : boxPage?.pay_card_button || "Pago con tarjeta de débito/crédito"}
                          </ButtonPrimaryStyled>
                        ) : null}
                      </>
                    )}
                  </ButtonsContainer>
                </form>
              </BillBoxStyled>
            </FlexStyled>
          </FlexStyled>
        </>
      ),
    },
  ];

  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <Box style={{ maxWidth: 1440 }}>
      <BillFlexStyled>
        {" "}
        <Form.Item label={isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 300 }} /> : (boxPage?.title || "Buscar estudiante por nombre o ID")}>
          <Select
            options={studentsOptions}
            filterOption={filterOption}
            placeholder={isLoadingContent ? "" : (boxPage?.select_option || "Búsqueda de estudiantes")}
            showSearch
            onSearch={(e) =>
              getStudents({
                rowsCount: 20,
                page: 1,
                estudianteNombre: e,
              })
            }
            optionFilterProp="children"
            allowClear
            loading={isLoadingStudents}
            onChange={(e) => {
              setCurrentStep(0);
              setSelectedStudent({
                id: e,
                name: students.data?.result?.find((st: any) => st.estudianteId == e)
                  ?.estudianteNombre,
              });
            }}
          />
        </Form.Item>
      </BillFlexStyled>
      {selectedStudent.id !== 0 ? (
        <>
          <SectionHeaderStyled style={{ height: isMobile ? "75px" : "35px", padding: 0 }}>
            <CartHeadingStyled>
              {steps.find((step) => step.id === currentStep)?.title}
            </CartHeadingStyled>
          </SectionHeaderStyled>

          {steps.find((st) => st.id === currentStep)?.component}
          {contextHolder}
        </>
      ) : (
        <Flex style={{ width: "100%", alignItems: "center", flexDirection: "column" }}>
          <SmallHeadingStyled>
            {isLoadingContent ? (
              <Skeleton.Input active size="default" style={{ width: 400 }} />
            ) : (
              boxPage?.empty_message || "Seleccione un estudiante para mostrar los cargos correspondientes"
            )}
          </SmallHeadingStyled>
          <Image src={NoResultsSVG} preview={false} alt="Ilustración sin resultados" width={200} />
        </Flex>
      )}
    </Box>
  );
};

export default ChargesSettings;
